/**
 * フィードバックのカテゴリ定義（アプリ共通）。
 * value/label/emoji/color/placeholder を全アプリで共有する。
 */
export const FEEDBACK_CATEGORIES = [
  {
    value: 'feature',
    label: '機能要望',
    emoji: '💡',
    color: '#2684FF',
    placeholder: '例: 一覧を並び替えできると便利です',
  },
  {
    value: 'bug',
    label: '不具合報告',
    emoji: '🐛',
    color: '#E01E5A',
    placeholder:
      '例: 画面が正しく表示されません。（発生時刻や操作手順も書いていただけると助かります）',
  },
  {
    value: 'other',
    label: '質問・その他',
    emoji: '💬',
    color: '#868686',
    placeholder: '例: 〇〇の操作方法を教えてください',
  },
] as const;

export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number]['value'];

/** 本文の最大文字数 */
export const FEEDBACK_MAX_LENGTH = 2000;
